import v from "./index47.js";
function u(n) {
  var a = n.hostname, r = a.split("."), l = r[r.length - 1], t = [];
  if (r.length === 4 && parseInt(l, 10) > 0 || r.length <= 1)
    return t;
  for (var e = r.length - 2; e >= 0; --e)
    t.push(r.slice(e).join("."));
  return t;
}
function o(n) {
  try {
    return new URL(n);
  } catch {
    return;
  }
}
function i(n) {
  var a = o(n);
  if (a)
    for (var r = u(a), l = 0; l < r.length; ++l) {
      var t = "__tld__", e = r[l], s = { domain: "." + e };
      try {
        if (v.set(t, "1", s), v.get(t))
          return v.remove(t, s), e;
      } catch {
        return;
      }
    }
}
export {
  i as tld
};
//# sourceMappingURL=index48.js.map
